module.exports = __webpack_public_path__ + "img/ceiling-lamp-lg.8ecff1cb.svg";